import React, { Component } from 'react'
import { Row, Container } from 'react-bootstrap'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { Field } from 'redux-form'

class CamposConsultaCupo extends Component {
  render () {
    return (
      <div className='wrapperConsultaCupo'>
        <Container>
          <Row>
            <Field
              name='numero'
              type='text'
              component={renderTextField}
              autoFocus
              required={false}
              placeholder='10200000000'
              maxLength={11}
            />
          </Row>
        </Container>
      </div>
    )
  }
}

export default CamposConsultaCupo
